import React from 'react';

var ClickAndColleck = function ClickAndColleck(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.344 8h5.342l-1.142-3.705a1 1 0 1 1 1.912-.59L16.779 8h1.217a3.002 3.002 0 0 1 2.962 3.5l-.206 1.222a1 1 0 0 1-1.972-.333l.206-1.223a1.002 1.002 0 0 0-.99-1.166H6.004a1 1 0 0 0-.99 1.166l1.184 7c.08.481.499.834.99.834h5.583a1 1 0 0 1 0 2H7.187a3.003 3.003 0 0 1-2.962-2.5l-1.183-7A3 3 0 0 1 6.004 8h1.252l1.286-4.287a1 1 0 0 1 1.916.575L9.344 8zm9.418 9.348l1.945 1.945a1 1 0 0 1-1.414 1.414l-1.915-1.914-.098.185a1.014 1.014 0 0 1-1.87-.195l-.883-3.044a1.014 1.014 0 0 1 1.265-1.255l2.954.884a1.014 1.014 0 0 1 .213 1.853l-.164.093-.033.034z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ClickAndColleck.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ClickAndColleck as icon };
export default iconHandler(ClickAndColleck);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ClickAndCollect.js
// module id = 590
// module chunks = 0